import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import audio.LocalSoundEngine
import audio.SoundEngine
import domain.player.PlayerSession
import rendering.BackgroundState
import rendering.LocalBackgroundState
import scenes.SceneHost

/**
 * Root composable shared by both platform entry points.
 *
 * Responsibilities:
 * 1. Initialise [PlayerSession] once on first composition.
 * 2. Provide the [SoundEngine] instance to the entire composition tree via
 *    [LocalSoundEngine].
 * 3. Hoist a single [BackgroundState] for the entire app lifetime so scene
 *    transitions don't reset the animated background.
 * 4. Host the [SceneHost] which manages scene navigation.
 *
 * @param soundEngine Platform-specific audio implementation injected by the
 *                    platform entry point (desktop or web).
 */
@Composable
fun GravitarApp(soundEngine: SoundEngine) {
    LaunchedEffect(Unit) {
        PlayerSession.init()
    }

    val bgState = remember { BackgroundState() }

    CompositionLocalProvider(
        LocalSoundEngine provides soundEngine,
        LocalBackgroundState provides bgState,
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.Black),
        ) {
            SceneHost()
        }
    }
}
